  const diamondDivider = document.querySelector('.step-item__divider_first');
  const ringDivider = document.querySelector('.step-item__divider_second');
  const stepItemFirst = document.querySelector('.step-item_first');
  const stepItemSecond = document.querySelector('.step-item_second');
  const stepItemContentSecond = document.querySelector('.step-item__content_second');
  const stepItemThird = document.querySelector('.step-item_third');
 

if (window.location.href.includes('/collections/rings')) {
  const ringBuilderTitleStep1 = document.querySelector('.collection-header__item__title_step-1');
  ringBuilderTitleStep1.style.color = 'black';
  ringBuilderTitleStep1.style.fontWeight = '500';
}

if (
  window.location.href.includes('pages/natural-diamonds') || 
  window.location.href.includes('pages/diamond-details') || 
  window.location.href.includes('pages/lab-diamonds')
) {
  const ringBuilderTitleStep2 = document.querySelector('.collection-header__item__title_step-2');
  if (ringBuilderTitleStep2) {
    ringBuilderTitleStep2.style.color = 'black';
    ringBuilderTitleStep2.style.fontWeight = '500';
  }

  const diamondImage = document.querySelector('.diamond-image');
  if (diamondImage || diamondDivider) {
    diamondImage.src = 'https://cdn.shopify.com/s/files/1/0825/9603/6927/files/dimond-pink.svg?v=1743507262';
    diamondDivider.src = "https://cdn.builder.io/api/v1/image/assets/TEMP/8c9c047fb00cd9d5d8eb81574f18b0f00b49f2ea?placeholderIfAbsent=true&apiKey=dda7e2069c7a43518b51315053293a51"
    ringDivider.style.display = "block"
    stepItemSecond.classList.add('step-item--active');
    stepItemSecond.style.justifyContent = "flex-start";
    stepItemFirst.style.minWidth = "255px";
    stepItemSecond.style.minWidth = "255px";
    stepItemContentSecond.style.paddingLeft = "20px";
  } else {
    console.warn('.diamond-image not found on the page.');
  }
}


if (window.location.href.includes('cart')) {
  const ringBuilderTitleStep3 = document.querySelector('.collection-header__item__title_step-3');
  ringBuilderTitleStep3.style.color = 'black';
  ringBuilderTitleStep3.style.fontWeight = '500';
  const completeDiamondImage = document.querySelector('.complete-ring');
  const completeDivider = document.querySelector('.step-item__divider_second');
  if (completeDiamondImage) {
    completeDiamondImage.src = 'https://cdn.shopify.com/s/files/1/0825/9603/6927/files/complete-ring.svg?v=1743599908';
    completeDivider.style.display = "block";
    diamondDivider.src = "https://cdn.builder.io/api/v1/image/assets/TEMP/8c9c047fb00cd9d5d8eb81574f18b0f00b49f2ea?placeholderIfAbsent=true&apiKey=dda7e2069c7a43518b51315053293a51"
    
    ringDivider.src = "https://cdn.builder.io/api/v1/image/assets/TEMP/8c9c047fb00cd9d5d8eb81574f18b0f00b49f2ea?placeholderIfAbsent=true&apiKey=dda7e2069c7a43518b51315053293a51"
    ringDivider.style.display = "block"
    stepItemSecond.classList.add('step-item--active');

    stepItemThird.classList.add('step-item--active');
  } else {
    console.warn('.diamond-image not found on the page.');
  }
}



function fetchCartItems() {
  let url = "https://www.shireeodiz.co.il/cart.js";
  fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // Для указания на AJAX запрос
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Обновляем элемент на странице с количеством товаров в корзине
      displayCartItems(data);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
}

function displayCartItems(cartItems) {
  cartItems.items.forEach((product, index) => {
    const cartContainer = document.querySelector('.card-container_step-2');
    if (product.product_type === "Engagement") {
      const firstStageNoData = document.querySelector('.collection-header__item_first-stage_no-data');
      const firstStageWithData = document.querySelector('.collection-header__item_first-stage_with-data');
      const priceElement = cartContainer.querySelector('.cart-container_step-2__price');
      const titleElement = cartContainer.querySelector('.cart-container_step-2__title');
      const viewLinkElement = cartContainer.querySelector('.cart-container_step-2__view-link');
      const removeLinkElement = cartContainer.querySelector('.cart-container_step-2__remove-link');
      const imageElement = cartContainer.querySelector('.cart-container_step-2__item-image');
      const indexElement = cartContainer.querySelector('.cart-container_step-2__index-info');


      firstStageWithData.style.display = 'flex';
      firstStageNoData.style.display = 'none';
      priceElement.textContent = `₪${product.presentment_price}`;
      indexElement.textContent = index;
      viewLinkElement.href = product.url;
      imageElement.src = product.image;
      imageElement.alt = product.name;
    }

    if (product.vendor == "Diamond Picker") {
      const cartContainer = document.querySelector('.card-container_step-3');
      console.log(index)
      const secondStageNoData = document.querySelector('.collection-header__item_second-stage_no-data');
      const secondStageWithData = document.querySelector('.collection-header__item_second-stage_with-data');
      const priceElement = cartContainer.querySelector('.cart-container_step-3__price');
      const titleElement = cartContainer.querySelector('.cart-container_step-3__title');
      const viewLinkElement = cartContainer.querySelector('.cart-container_step-3__view-link');
      const removeLinkElement = cartContainer.querySelector('.cart-container_step-3__remove-link');
      const imageElement = cartContainer.querySelector('.cart-container_step-3__item-image');
      const indexElement = cartContainer.querySelector('.cart-container_step-3__index-info');


      secondStageWithData.style.display = 'flex';
      secondStageNoData.style.display = 'none';
      priceElement.textContent = `₪${product.presentment_price}`;
      indexElement.textContent = index;
      viewLinkElement.href = product.url;
      imageElement.src = product.image;
      imageElement.alt = product.name;
    }
  })
}


fetchCartItems();



  document.addEventListener('DOMContentLoaded', () => {

    function handleRemoveLinkClickDiamond(event) {
      event.preventDefault();

      const element = event.currentTarget;

      if (!confirm('Are you sure you want to remove this item?')) return;

      const parentCard = element.closest('.card-container_step-3');
      const indexInfoElement = parentCard?.querySelector('.cart-container_step-3__index-info');
      const indexValue = indexInfoElement?.textContent.trim();

      console.log(indexValue, "indexValue");

      if (indexValue) {
        const newHref = element.href.replace('line=1', 'line=1');

        fetch(newHref, { method: 'GET' })
          .then(response => {
            if (response.ok) {
              window.location.href = 'https://www.shireeodiz.co.il/pages/natural-diamonds';
            } else {
              alert('Failed to remove item.');
            }
          })
          .catch(error => {
            console.error('Error:', error);
            alert('An error occurred while removing the item.');
          });
      } else {
        alert('Unable to find the index information.');
      }
    }

       function handleRemoveLinkClickRing(event) {
      event.preventDefault();

      const element = event.currentTarget;

      if (!confirm('Are you sure you want to remove this item?')) return;

      const parentCard = element.closest('.card-container_step-2');
      const indexInfoElement = parentCard?.querySelector('.cart-container_step-2__index-info');
      const indexValue = indexInfoElement?.textContent.trim();

      console.log(indexValue, "indexValue");

      if (indexValue) {
        const newHref = element.href.replace('line=0', 'line=0');

        fetch(newHref, { method: 'GET' })
          .then(response => {
            if (response.ok) {
              window.location.href = 'https://www.shireeodiz.co.il/collections/rings';
            } else {
              alert('Failed to remove item.');
            }
          })
          .catch(error => {
            console.error('Error:', error);
            alert('An error occurred while removing the item.');
          });
      } else {
        alert('Unable to find the index information.');
      }
    }

    const removeLinksDiamond = document.querySelectorAll('.cart-container_step-3__remove-link');
    removeLinksDiamond.forEach(link => {
      link.addEventListener('click', handleRemoveLinkClickDiamond);
    });

        const removeLinksSetting = document.querySelectorAll('.cart-container_step-2__remove-link');
    removeLinksSetting.forEach(link => {
      link.addEventListener('click', handleRemoveLinkClickRing);
    });

  });



function initShapeBoxListeners() {
  const shapeBoxes = document.querySelectorAll('.shape-box');
  if (!shapeBoxes.length) return;

  shapeBoxes.forEach(box => {
    box.addEventListener('click', () => {
      // Удаляем класс 'active' со всех shape-box
      document.querySelectorAll('.shape-box').forEach(el => {
        el.classList.remove('active');
      });

      // Добавляем класс 'active' к текущему
      box.classList.add('active');
    });
  });
}

// Ждём появления хотя бы одного .shape-box
const observer = new MutationObserver((mutations, obs) => {
  const shapeBoxExists = document.querySelector('.shape-box');
  if (shapeBoxExists) {
    initShapeBoxListeners();
    obs.disconnect(); // Отключаем наблюдатель после первого срабатывания
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});